<template>
<div class="stend-page">
	<h1>My Stend</h1>

	<h2>Кнопка</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<TirPmButton :variant="TirPmButtonVariantEnum.AccentState" class="mr-10">
				Без названия</TirPmButton>
			<TirPmButton :variant="TirPmButtonVariantEnum.PrimaryState" @click="changeMessage()">
				Без названия</TirPmButton>
		</div>
		<div class="stend-code">
			<pre>
					<code>
{{ `
<TirPmButton :variant="TirPmButtonVariantEnum.AccentState">
	Без названия
</TirPmButton>
` }}
					</code>
				</pre>
		</div>
	</div>

	<h2>Поле ввода</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<TirPmInput v-model="message" :isSmallSize="true" :label="'Найти'" :placeholder="'Найти'" @update:modelValue="changeMessage" />
			<TirPmTextarea
              label="Комментарий"
              placeholder="Текст комментария..."
              v-model="message"
              :isWithHint="false"
            >
            </TirPmTextarea>
		</div>
		<div class="stend-code">
			<pre>
					<code>
{{ `
<TirPmInput v-model="message"
:isSmallSize="true" :label="'Найти'"
:placeholder="'Найти'" @update:modelValue="changeMessage"/>	
`}}
{{ `
<TirPmTextarea
 label="Комментарий"
 placeholder="Текст комментария..."
 v-model="message"
 :isWithHint="false">
</TirPmTextarea>
`}}
		</code>
		</pre>
		</div>
	</div>


	<h2>Чек бокс</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<TirCheckbox v-model="checked"> <template #mainSign>Checkbox</template></TirCheckbox>
		</div>
		<div class="stend-code">
			<pre>
		<code>
{{`
<TirCheckbox v-model="checked"> <template #mainSign>Checkbox</template></TirCheckbox>
`}}
		</code>
	</pre>
		</div>
	</div>


	<h2>Радио</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<TirPmRadio style="width: 100%" name="Status" :value="5" v-model="status">
				<template #mainSign>В архиве 5</template>
			</TirPmRadio>
			<TirPmRadio style="width: 100%" name="Status" :value="3" v-model="status">
				<template #mainSign>В архиве 3</template>
			</TirPmRadio>
			{{ status }}
		</div>
		<div class="stend-code">
			<pre>
			<code>
{{ `
<TirPmRadio style="width: 100%" name="Status" :value="5" v-model="status">
 <template #mainSign>В архиве 5</template>
</TirPmRadio>
<TirPmRadio style="width: 100%" name="Status" :value="3" v-model="status">
 <template #mainSign>В архиве 3</template>
</TirPmRadio>
`}}
			</code>
		</pre>
		</div>
	</div>



	<h2>Тогл</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<TirToggle><template #mainSign>Test</template></TirToggle>
		</div>
		<div class="stend-code">
			<pre>
			<code>
				{{ `
<TirToggle>1</TirToggle>
				`}}
			</code>
		</pre>
		</div>
	</div>


	<h2>TirPmIconView</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<!-- <TirPmIconView :size="24" isRounded imageLoadUrl="@assets/images/new/im1test.jpg">
				<template #mainSlot> simple text </template>
			</TirPmIconView>
			<TirPmIndicator size="xs" isBordered>123</TirPmIndicator> -->
		</div>
		<div class="stend-code">
			<pre>
			<code>
{{ `
<TirPmIconView :size="24" isRounded imageLoadUrl="@assets/images/new/im1test.jpg">
 <template #mainSlot> simple text </template>
</TirPmIconView>
<TirPmIndicator size="xs" isBordered>123</TirPmIndicator>
`}}
			</code>
		</pre>
		</div>
	</div>


	<h2>Tabs</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			{{ stateTabs }}
			<Tabs v-model="stateTabs">
				<Tab :val="tabs[0]" label="Name1" :currentTab="stateTabs" />
				<Tab :val="tabs[1]" label="Name2" :currentTab="stateTabs" />
				<Tab :val="tabs[2]" label="Name3" :currentTab="stateTabs" />
			</Tabs>
			<h2>TirPmScrollbar</h2>
			<TirPmScrollbar style="max-height: calc(100vh - (3.563rem + 1.313rem + 1.313rem + 3.688rem))">
				<div v-if="'A' == stateTabs">
					Lorem ipsum dolor sit amet consectetur adipisicing elit. In perferendis labore
					libero mollitia, laborum corrupti laudantium praesentium? Expedita modi, rerum
					distinctio maiores nisi aperiam, quas adipisci consequuntur ex nostrum fugiat?
				</div>
				<div v-if="'B' == stateTabs">
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex cum, voluptates
					repudiandae eos alias minima vitae harum vero exercitationem blanditiis
					asperiores, quia sint. Nihil cupiditate sint veritatis. Vel animi ea ratione,
					dignissimos porro nulla, eum quas facere veniam libero excepturi dolore fugiat
					enim! Obcaecati eaque, perspiciatis totam inventore fugit dolorum temporibus
					adipisci quibusdam. Explicabo voluptatum omnis expedita itaque earum reiciendis,
					quam dolores sint doloribus possimus facilis inventore! Eveniet, architecto beatae
					repellendus veniam amet veritatis, ratione ipsum ab minus, delectus dolor sit?
					Laudantium sunt cum corrupti fugiat eligendi soluta, facilis odio odit error
					inventore nostrum iure doloremque explicabo labore facere perferendis
					ducimus laboriosam quo corporis ex deserunt quod! Culpa sit itaque numquam ut
					officiis, optio necessitatibus ratione est praesentium quam suscipit quidem
					sapiente cupiditate. Voluptatem quos cum incidunt optio ipsum, ex nulla beatae
					nihil explicabo distinctio ab, dolorem dolores, officia provident eos? Nulla velit
					error maiores, aut illum molestias. Perferendis dolorem molestias deleniti ipsa
					aliquid provident tenetur possimus quisquam est, recusandae nesciunt ad reiciendis
					omnis officiis unde corporis consequuntur. Ut tempore dolorem repellendus sint
					fugit reiciendis quisquam aut quos ex sed, magni, voluptatum temporibus excepturi
					et quidem labore perspiciatis ab qui voluptas adipisci odit necessitatibus in
					dolore iste? Quod cupiditate harum dignissimos accusantium, quos reprehenderit ut
					commodi pariatur officia nisi exercitationem tempora alias iste adipisci molestias
					expedita tenetur vitae veniam. Illo maxime ab doloremque consequatur hic ratione
					necessitatibus eos voluptatum, quis explicabo illum neque. Id voluptatem sed atque
					veritatis hic? Ut, alias eaque autem quibusdam dolores distinctio minus nihil quos
					cumque nisi mollitia consectetur a incidunt fugiat quasi, dolor vel pariatur
					placeat amet nesciunt aut voluptatibus. Reprehenderit, laudantium.
				</div>
				<div v-if="'B' == stateTabs">
					Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum rerum praesentium
					non maxime ratione, fugiat rem sed deserunt vero ipsa impedit sunt illum, error ad
					expedita quas laborum enim iure. Consectetur reprehenderit, sit quae iste earum ut
					rem delectus consectetur quod suscipit voluptas tempore non. Excepturi dignissimos
					amet totam corporis vero commodi sequi temporibus reprehenderit. Temporibus amet
					delectus, tempora totam corrupti quae eos autem maiores explicabo, harum ipsam
					provident a iure tempore illum soluta iusto fugit quibusdam voluptate quam
					consectetur excepturi architecto aspernatur animi? Facere, optio, neque molestias,
					culpa atque dolore debitis ex placeat facilis ea at. Perferendis enim iusto quod
					rerum voluptates, nulla impedit accusantium tempore minus, beatae quasi esse!
					Molestias ipsa nulla tenetur, nostrum non excepturi cumque labore consectetur
					assumenda! Omnis a nostrum illum excepturi debitis.
				</div>
			</TirPmScrollbar>
		</div>
		<div class="stend-code">
			<pre>
			<code>
				{{ `
<Tabs v-model="stateTabs">
 <Tab :val="tabs[0]" label="Name1" :currentTab="stateTabs" />
 <Tab :val="tabs[1]" label="Name2" :currentTab="stateTabs" />
 <Tab :val="tabs[2]" label="Name3" :currentTab="stateTabs" />
</Tabs>
<h2>TirPmScrollbar</h2>
<TirPmScrollbar style="max-height: calc(100vh - (3.563rem + 1.313rem + 1.313rem + 3.688rem))">
 <div v-if="'A' == stateTabs">
  Lorem ipsum dolor sit amet consectetur adipisicing elit. In perferendis labore
  libero mollitia, laborum corrupti laudantium praesentium? Expedita modi, rerum
  distinctio maiores nisi aperiam, quas adipisci consequuntur ex nostrum fugiat?
 </div>
<div v-if="'B' == stateTabs">
 Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex cum, voluptates
 repudiandae eos alias minima vitae harum vero exercitationem blanditiis
 totam nemo corrupti molestiae ipsa nesciunt, aliquid illum quaerat officia ipsam,
 maxime numquam dignissimos! Minima, ex tempore. Nulla ad placeat consectetur
 necessitatibus eos voluptatum, quis explicabo illum neque. Id voluptatem sed atque
 veritatis hic? Ut, alias eaque autem quibusdam dolores distinctio minus nihil quos
 cumque nisi mollitia consectetur a incidunt fugiat quasi, dolor vel pariatur
 placeat amet nesciunt aut voluptatibus. Reprehenderit, laudantium.
</div>
<div v-if="'B' == stateTabs">
 Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum rerum praesentium
 non maxime ratione, fugiat rem sed deserunt vero ipsa impedit sunt illum, error ad
 expedita quas laborum enim iure. Consectetur reprehenderit, sit quae iste earum ut
 reiciendis laborum? Sit quod eligendi aliquid. Culpa praesentium laborum eligendi
 veniet odit natus provident temporibus omnis soluta in quaerat corporis illum,
 iste nemo aspernatur odio est doloribus quis? Molestias reprehenderit quisquam
 dolores recusandae nam soluta, itaque quis dolorum neque, voluptate voluptatibus
 rem delectus consectetur quod suscipit voluptas tempore non. Excepturi dignissimos
</div>
</TirPmScrollbar>
`}}
			</code>
		</pre>
		</div>
	</div>


	<h2>Таблица</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<TirPmTable :columns="columnTableSetting" :isBordered="true">
		<template #topSlot>
			<div class="">Текст до шапки таблицы названия столбцов</div>
		</template>
		<template #emptyDataSlot>
			<TirPmSystemMessage style="width: 100%">
				<template #topDescImage> </template>
				<template #mainTitleSlot>Нет пользователей</template>
				<template #mainSubtitleSlot>
					Поменяйте параметры фильтра или перезагрузите</template>
				<template #actionsSlot>
					<TirPmButton :variant="TirPmButtonVariantEnum.AccentState">Close</TirPmButton>
				</template>
			</TirPmSystemMessage>
		</template>
		<template #tableHead>
			<TirPmTableTh :isLeftBorder="false">Фото</TirPmTableTh>
			<TirPmTableTh isLeftBorder>ФИО</TirPmTableTh>
			<TirPmTableTh isLeftBorder>Проекты</TirPmTableTh>
			<TirPmTableTh isLeftBorder>Почта</TirPmTableTh>
		</template>
		<template #tableBody>
			<TirPmTableTr :columns="columnTableSetting">
				<TirPmTableTd style="overflow: visible !important">
					<TirPmTooltipElement>
						ssssssss1
						<template #content>Project Name11</template>
					</TirPmTooltipElement>
				</TirPmTableTd>
				<TirPmTableTd style="overflow: visible !important">
					<TirPmTooltipElement>
						ddddddd2
						<template #content>Project Name</template>
					</TirPmTooltipElement>
				</TirPmTableTd>
				<TirPmTableTd style="overflow: visible !important">
					<!-- <TirPmTooltipElement>
						<img width="100" height="100" src="@assets/images/new/im1test.jpg" />
						<template #content>Project Name2</template>
					</TirPmTooltipElement> -->
				</TirPmTableTd>
				<TirPmTableTd style="overflow: visible !important">
					<TirPmTooltipElement>
						rrrrr4
						<template #content>Project Name3</template>
					</TirPmTooltipElement>
				</TirPmTableTd>
			</TirPmTableTr>
		</template>
	</TirPmTable>
		</div>
		<div class="stend-code">
			<pre>
		<code>
{{`
<TirPmTable :columns="columnTableSetting" :isBordered="true">
		<template #topSlot>
			<div class="">Текст до шапки таблицы названия столбцов</div>
		</template>
		<template #emptyDataSlot>
			<TirPmSystemMessage style="width: 100%">
				<template #topDescImage> </template>
				<template #mainTitleSlot>Нет пользователей</template>
				<template #mainSubtitleSlot>
					Поменяйте параметры фильтра или перезагрузите</template>
				<template #actionsSlot>
					<TirPmButton :variant="TirPmButtonVariantEnum.AccentState">Close</TirPmButton>
				</template>
			</TirPmSystemMessage>
		</template>
		<template #tableHead>
			<TirPmTableTh :isLeftBorder="false">Фото</TirPmTableTh>
			<TirPmTableTh isLeftBorder>ФИО</TirPmTableTh>
			<TirPmTableTh isLeftBorder>Проекты</TirPmTableTh>
			<TirPmTableTh isLeftBorder>Почта</TirPmTableTh>
		</template>
		<template #tableBody>
			<TirPmTableTr :columns="columnTableSetting">
				<TirPmTableTd style="overflow: visible !important">
					<TirPmTooltipElement>
						ssssssss1
						<template #content>Project Name11</template>
					</TirPmTooltipElement>
				</TirPmTableTd>
				<TirPmTableTd style="overflow: visible !important">
					<TirPmTooltipElement>
						ddddddd2
						<template #content>Project Name</template>
					</TirPmTooltipElement>
				</TirPmTableTd>
				<TirPmTableTd style="overflow: visible !important">
					<TirPmTooltipElement>
						<img width="100" height="100" src="@assets/images/new/im1test.jpg" />
						<template #content>Project Name2</template>
					</TirPmTooltipElement>
				</TirPmTableTd>
				<TirPmTableTd style="overflow: visible !important">
					<TirPmTooltipElement>
						rrrrr4
						<template #content>Project Name3</template>
					</TirPmTooltipElement>
				</TirPmTableTd>
			</TirPmTableTr>
		</template>
	</TirPmTable>
`}}
		</code>
	</pre>
		</div>
	</div>


	<h2>Пагинация</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<TirPmPagination v-model="currentPageNum" style="width: 100%" :range-size="2" :show-on-page="limitPerPage" :pages="Math.ceil(totalPageNum / limitPerPage)"><template #leftSlot>
			<TirPmOptionList :isOpened="false" :vertical-position="{
				x: TirPmOptionListPositionEnum.Left,
				y: TirPmOptionListPositionEnum.Top,
			}">
				<template #content>
					<TirPmOptionListItemElement @click="changeLimitPerPage(25)">
						25
					</TirPmOptionListItemElement>
					<TirPmOptionListItemElement @click="changeLimitPerPage(50)">50
					</TirPmOptionListItemElement>
					<TirPmOptionListItemElement @click="changeLimitPerPage(100)">100
					</TirPmOptionListItemElement>
				</template>
				<template #optionListTarget="{ isOpened }">
					<div style="
								display: flex;
								align-items: center;
								gap: 0.25rem;
								color: var(--text-primary);
								font-weight: 500;
							">
						Показывать по {{ limitPerPage }}
						<ChevronDownIcon style="width: 1rem; height: 1rem"></ChevronDownIcon>
					</div>
				</template>
			</TirPmOptionList>
		</template>
	</TirPmPagination>
		</div>
		<div class="stend-code">
			<pre>
		<code>
{{`
	<TirPmPagination v-model="currentPageNum" style="width: 100%" :range-size="2" :show-on-page="limitPerPage" :pages="Math.ceil(totalPageNum / limitPerPage)"><template #leftSlot>
			<TirPmOptionList :isOpened="false" :vertical-position="{
				x: TirPmOptionListPositionEnum.Left,
				y: TirPmOptionListPositionEnum.Top,
			}">
				<template #content>
					<TirPmOptionListItemElement @click="changeLimitPerPage(25)">
						25
					</TirPmOptionListItemElement>
					<TirPmOptionListItemElement @click="changeLimitPerPage(50)">50
					</TirPmOptionListItemElement>
					<TirPmOptionListItemElement @click="changeLimitPerPage(100)">100
					</TirPmOptionListItemElement>
				</template>
				<template #optionListTarget=" isOpened">
					<div style="
								display: flex;
								align-items: center;
								gap: 0.25rem;
								color: var(--text-primary);
								font-weight: 500;
							">
						Показывать по  limitPerPage 
						<ChevronDownIcon style="width: 1rem; height: 1rem"></ChevronDownIcon>
					</div>
				</template>
			</TirPmOptionList>
		</template>
	</TirPmPagination>
`}}
		</code>
	</pre>
		</div>
	</div>
	
	<h2>Select</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<div style="position: relative">
        Some content
				<TirPmOptionList
        :vertical-position="{
          x: TirPmOptionListPositionEnum.Bottom,
          y: TirPmOptionListPositionEnum.Right,
        }"
        :width="450"
        :isOpened="false"
        
      >
        <template #content>
          <TirPmOptionListItemElement class="" style="gap: 0.625rem">
            <UserIcon style="width: 1.5rem; height: 1.5rem"></UserIcon>Еще проект
          </TirPmOptionListItemElement>
          <TirPmOptionListItemElement class="" style="gap: 0.625rem">
            <UserIcon style="width: 1.5rem; height: 1.5rem"></UserIcon>Еще проект
          </TirPmOptionListItemElement>
          <TirPmOptionListItemElement class="" style="gap: 0.625rem">
            <UserIcon style="width: 1.5rem; height: 1.5rem"></UserIcon>Еще проект
          </TirPmOptionListItemElement>
          <TirPmOptionListItemElement class="" style="gap: 0.625rem">
            <UserIcon style="width: 1.5rem; height: 1.5rem"></UserIcon>Еще проект
          </TirPmOptionListItemElement>
        </template>
        <template #optionListTarget="{ isOpened }">
          <div class="sidebar__current-project" style="">
            <div class="sidebar__current-project-logo">
              <img src="" alt="" />
            </div>
            <div class="">dddddddd</div>
          </div>
        </template>
      </TirPmOptionList>
</div>
		</div>
		<div class="stend-code">
			<pre>
		<code>
{{`
	<TirPmOptionList
        :vertical-position="{
          x: TirPmOptionListPositionEnum.Bottom,
          y: TirPmOptionListPositionEnum.Right,
        }"
        :width="450"
        :isOpened="false"
        
      >
        <template #content>
          <TirPmOptionListItemElement class="" style="gap: 0.625rem">
            <UserIcon style="width: 1.5rem; height: 1.5rem"></UserIcon>Еще проект
          </TirPmOptionListItemElement>
          <TirPmOptionListItemElement class="" style="gap: 0.625rem">
            <UserIcon style="width: 1.5rem; height: 1.5rem"></UserIcon>Еще проект
          </TirPmOptionListItemElement>
          <TirPmOptionListItemElement class="" style="gap: 0.625rem">
            <UserIcon style="width: 1.5rem; height: 1.5rem"></UserIcon>Еще проект
          </TirPmOptionListItemElement>
          <TirPmOptionListItemElement class="" style="gap: 0.625rem">
            <UserIcon style="width: 1.5rem; height: 1.5rem"></UserIcon>Еще проект
          </TirPmOptionListItemElement>
        </template>
        <template #optionListTarget="{ isOpened }">
          <div class="sidebar__current-project" style="">
            <div class="sidebar__current-project-logo">
              <img src="" alt="" />
            </div>
            <div class="">dddddddd</div>
          </div>
        </template>
      </TirPmOptionList>
`}}
		</code>
	</pre>
		</div>
	</div>





<h2>Status</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<TirPmStatus
          label="label"
          :bgColor="TirPmStatusBgEnum.BgPositive"
          :labelColor="TirPmStatusTextEnum.Positive"
        >
</TirPmStatus>
	<TirPmStatus
          label="labelText"
          :bgColor="TirPmStatusBgEnum.BgAttention"
          :labelColor="TirPmStatusTextEnum.Attention"
        >
</TirPmStatus>
		</div>
		<div class="stend-code">
			<pre>
			<code>
				{{ `
	<TirPmStatus
          label="label"
          :bgColor="TirPmStatusBgEnum.BgPositive"
          :labelColor="TirPmStatusTextEnum.Positive"
        >
</TirPmStatus>
	<TirPmStatus
          label="labelText"
          :bgColor="TirPmStatusBgEnum.BgAttention"
          :labelColor="TirPmStatusTextEnum.Attention"
        >
</TirPmStatus>
				`}}
			</code>
		</pre>
		</div>
	</div>



	<h2>Modal</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<TirPmButton @click="isShow=!isShow">isShow Modal</TirPmButton>
	<TirPmModal
    :isVisible="isShow"
    @close="isShow = false"
    :number-step="numberStep"
    @back-step="toBackStep"
    is-with-step
    :is-with-back="false"
    title="Title 26-32" >
    <template #content>
        <div class="modal-content">Content Number Of Step {{ numberStep }}</div>
				Lorem ipsum dolor sit, amet consectetur adipisicing elit. Vel quidem tempore aliquam illum assumenda nam, consequuntur nisi at corrupti officiis quos aliquid, modi asperiores quae ullam voluptas doloribus ab qui!
    </template>
    <template #footer>
        <!-- Любое содержимое. Обычно кнопки -->
				<tir-pm-button :variant="TirPmButtonVariantEnum.PrimaryState" @click="isShow=!isShow" >Close</tir-pm-button>
    </template>
</TirPmModal>
		</div>
		<div class="stend-code">
			<pre>
			<code>
				{{ `
<TirPmButton @click="isShow=!isShow">isShow Modal</TirPmButton>
	<TirPmModal
    :isVisible="isShow"
    @close="isShow = false"
    :number-step="numberStep"
    @back-step="toBackStep"
    is-with-step
    :is-with-back="false"
    title="Title 26-32" >
    <template #content>
        <div class="modal-content">Content Number Of Step  numberStep </div>
				Lorem ipsum dolor sit, amet consectetur adipisicing elit. Vel quidem tempore aliquam illum assumenda nam, consequuntur nisi at corrupti officiis quos aliquid, modi asperiores quae ullam voluptas doloribus ab qui!
    </template>
    <template #footer>
        <!-- Любое содержимое. Обычно кнопки -->
				<tir-pm-button :variant="TirPmButtonVariantEnum.PrimaryState" @click="isShow=!isShow" >Close</tir-pm-button>
    </template>
</TirPmModal>
				`}}
			</code>
		</pre>
		</div>
	</div>





	<h2>Dropdown</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<TirPmDropdown
      :options="options"
      :selected-option="selectedOption"
      :size="TirPmDropdownSizeEnum.Light"
      
      
      placeholder="Статус"
    >
      <template #selectedContent>
        <div class="selected-option" v-if="selectedOption">
                   <span class="text">{{ selectedOption.Name }}</span>
        </div>
      </template>
      <template #optionList="{ option }">
        <div class="option" @click="selectOption(option)">
          {{ option.Name }}
        </div>
      </template>
    </TirPmDropdown>
		</div>
		<div class="stend-code">
			<pre>
			<code>
				{{ `

<TirPmDropdown
      :options="options"
      :selected-option="selectedOption"
      :size="TirPmDropdownSizeEnum.Light"
      width="128px"
      popover-width="164px"
      placeholder="Статус"
    >
      <template #selectedContent>
        <div class="selected-option" v-if="selectedOption">
          <span class="text">{ { selectedOption.Name } }</span>
        </div>
      </template>
      <template #optionList="{ option }">
        <div class="option" @click="selectOption(option)">
          { { option.Name } }
        </div>
      </template>
    </TirPmDropdown>
				`}}
			</code>
		</pre>
		</div>
	</div>





	<!-- <Toast group="123" :bunner="true" :zIndex="1000" /> -->



	<h2>Тогл</h2>
	<div class="stend-wrap">
		<div class="stend-element">
			<TirPmMultiselect
    style="width: 520px"
    label="Администраторы рабочей области"
    :options="options1"
    :selected-options="selectedOptions"
    search-input-label="Поиск сотрудников"
  >
    <template #optionList="{ option }">
      <div
        style="display: flex; align-items: center; gap: 10px; padding: 12px"
        @click="toggleSelectEmployee(option.Id)"
      >
        <div style="width: 24px; height: 24px">
          <TirPmIconView :size="24">
            <template #mainSlot>
              <img :src="option.Image" />
            </template>
          </TirPmIconView>
        </div>
        {{ option.Name }}
      </div>
    </template>
    <template #selectedContent>
      <div style="display: flex; gap: 2px; flex-wrap: wrap">
        <TirPmSelectBadge
          v-for="(option, idx) in selectedOptions"
					:key="idx" 
          is-closable
          @close="unSelectEmployee(option.Id)"
        >
          <template #sign>
            {{ option.Name }}
          </template>
          <template #iconViewAddon>
            <div style="width: 24px; height: 24px">
              <TirPmIconView :size="24">
                <template #mainSlot>
                  <img :src="option.Image" />
                </template>
              </TirPmIconView>
            </div>
          </template>
        </TirPmSelectBadge>
      </div>
    </template>
    <template #left>
      <div>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 24.002C18.6274 24.002 24 18.6294 24 12.002C24 5.37451 18.6274 0.00195312 12 0.00195312C5.37256 0.00195312 0 5.37451 0 12.002C0 18.6294 5.37256 24.002 12 24.002ZM12.25 9.08521C12.8253 9.08521 13.2917 8.6189 13.2917 8.0437C13.2917 7.46826 12.8253 7.00195 12.25 7.00195C11.6747 7.00195 11.2083 7.46826 11.2083 8.0437C11.2083 8.6189 11.6747 9.08521 12.25 9.08521ZM11 11.5852V10.752H12.6667C12.8968 10.752 13.0833 10.9385 13.0833 11.1687V15.752H13.5V16.5852H11V15.752H11.4167V11.5852H11Z"
            fill="#272D37"
          />
        </svg>
      </div>
    </template>
  </TirPmMultiselect>

		</div>
		<div class="stend-code">
			<pre>
			<code>
				{{ `
  <TirPmMultiselect
    style="width: 520px"
    label="Администраторы рабочей области"
    :options="options1"
    :selected-options="selectedOptions"
    search-input-label="Поиск сотрудников"
  >
    <template #optionList="{ option }">
      <div
        style="display: flex; align-items: center; gap: 10px; padding: 12px"
        @click="toggleSelectEmployee(option.Id)"
      >
        <div style="width: 24px; height: 24px">
          <TirPmIconView :size="24">
            <template #mainSlot>
              <img :src="option.Image" />
            </template>
          </TirPmIconView>
        </div>
        { { option.Name } }
      </div>
    </template>
    <template #selectedContent>
      <div style="display: flex; gap: 2px; flex-wrap: wrap">
        <TirPmSelectBadge
          v-for="(option, idx) in selectedOptions"
					:key="idx" 
          is-closable
          @close="unSelectEmployee(option.Id)"
        >
          <template #sign>
            { { option.Name } }
          </template>
          <template #iconViewAddon>
            <div style="width: 24px; height: 24px">
              <TirPmIconView :size="24">
                <template #mainSlot>
                  <img :src="option.Image" />
                </template>
              </TirPmIconView>
            </div>
          </template>
        </TirPmSelectBadge>
      </div>
    </template>
    <template #left>
      <div>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 24.002C18.6274 24.002 24 18.6294 24 12.002C24 5.37451 18.6274 0.00195312 12 0.00195312C5.37256 0.00195312 0 5.37451 0 12.002C0 18.6294 5.37256 24.002 12 24.002ZM12.25 9.08521C12.8253 9.08521 13.2917 8.6189 13.2917 8.0437C13.2917 7.46826 12.8253 7.00195 12.25 7.00195C11.6747 7.00195 11.2083 7.46826 11.2083 8.0437C11.2083 8.6189 11.6747 9.08521 12.25 9.08521ZM11 11.5852V10.752H12.6667C12.8968 10.752 13.0833 10.9385 13.0833 11.1687V15.752H13.5V16.5852H11V15.752H11.4167V11.5852H11Z"
            fill="#272D37"
          />
        </svg>
      </div>
    </template>
  </TirPmMultiselect>

				`}}
			</code>
		</pre>
		</div>




</div>

<tir-pm-button @click="showNotify1">Показать Уведомление Успешное</tir-pm-button>
<tir-pm-button @click="showNotify2">Показать Уведомление Не успешное</tir-pm-button>

<div class="d-flex flex-wrap">
						<TirPmButton :variant="TirPmButtonVariantEnum.LinkState" :size="TirPmButtonSizeEnum.Small">
							<template #leftSlot>
								<PencilSquareIcon />
							</template>
						</TirPmButton>
						<TirPmButton :variant="TirPmButtonVariantEnum.LinkState" :size="TirPmButtonSizeEnum.Small">
							<template #leftSlot>
								<TrashIcon />
							</template>
						</TirPmButton>
						<TirPmButton :variant="TirPmButtonVariantEnum.LinkState" :size="TirPmButtonSizeEnum.Small">
							<template #leftSlot>
								<PlusIcon />
							</template>
						</TirPmButton>
						<!-- <TirPmTimepickerRange v-model="valueDate" /> -->
	</div>

</div>
<TirPmNotificationGroup
    group="test"
    position="top-right"
    :zIndex="20000"
  />
</template>

<script setup lang="ts">
// Импорты из Vue 3 Composition API
import { ref, computed, defineProps, defineEmits, onMounted, watch } from "vue";
// import { DatepickerDate,TirPmDatepickerRange } from "tir-pm-datepicker";
import {
  TirPmOptionList,
  TirPmOptionListItemElement,
  TirPmOptionListGroupSeparator,
} from 'tir-pm-option-list'
import {
	Tab,
	Tabs,
	TirCheckbox,
	TirPmButton,
	TirPmButtonSizeEnum,
	TirPmButtonVariantEnum,
	TirPmInput,
	TirPmRadio,
	TirToggle,
	TirPmIconView,
	TirPmScrollbar,
	TirPmIndicator,
	TirPmSystemMessage,
	TirPmPagination,
	TirPmOptionListPositionEnum,
	TirPmStatusBgEnum,
	TirPmStatusTextEnum,
	TirPmStatus, 
	TirPmNotificationGroup,
	Toast,
	TirPmModal,
	ITirPmDropdownOption,
	TirPmDropdownSizeEnum,
	TirPmDropdown,
	TirPmSelectBadge,
	ITirPmMultiselectOption,
	TirPmMultiselect,
	TirPmNotificationEventBus,
	TirPmNotificationModel,
	

} from "tir-components";
import { TirPmTable, TirPmTableTd, TirPmTableTh, TirPmTableTr } from "tir-pm-table";
import {
	PencilSquareIcon,
	PlusIcon,
	TrashIcon,
} from "tir-style-system/icons/outline";
import {
	TirPmTooltipElement,
	TirPmTooltipElementPlacementEnum,
} from "tir-pm-tooltip-element";
// // Определение пропсов компонента
const props = defineProps({
	isCompact: { type: Boolean, value: true },
	msg: { type: String, default: "" },
});
// import i1 from "@assets/images/new/im1test.jpg";
// const valueDate = ref<[DatepickerDate, DatepickerDate]>();
function showNotify1(){

	
      TirPmNotificationEventBus.emit(
        "add",
        new TirPmNotificationModel({
          title: "Файл был успешно загружен",
          type: "success",
          group: "test",
          life: 2000,
          closable: true,
        }),
      );
  
    

}
function showNotify2(){
console.log("showNotify2");
console.log(TirPmNotificationEventBus)

      TirPmNotificationEventBus.emit(
        "add",
        new TirPmNotificationModel({
          title: "Произошла ошибка при загрузке файла",
          type: "error",
          group: "test",
          life: 2000,
          closable: true,
        }),
      );

}


class EmployeeModel implements ITirPmMultiselectOption {
  Id!: string;
  Name!: string;
  Image: string =
    "https://avataaars.io/?avatarStyle=Circle&topType=LongHairStraight&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light";

  search = (searchStr: string) => {
    if (!searchStr?.trim()) return true;
    return this.Name.toLocaleLowerCase().includes(
      searchStr.toLocaleLowerCase()
    );
  };

  constructor(obj?: Partial<EmployeeModel>) {
    Object.assign(this, obj);
  }
}

const options1 = ref([
  new EmployeeModel({
    Id: "1",
    Name: "Владислав",
  }),
  new EmployeeModel({
    Id: "2",
    Name: "Ярослав",
  }),
  new EmployeeModel({
    Id: "3",
    Name: "Михаил",
  }),
  new EmployeeModel({
    Id: "4",
    Name: "Николай",
  }),
  new EmployeeModel({
    Id: "5",
    Name: "Николай",
  }),
  new EmployeeModel({
    Id: "6",
    Name: "Николай",
  }),
  new EmployeeModel({
    Id: "7",
    Name: "Николай",
  }),
  new EmployeeModel({
    Id: "8",
    Name: "Николай",
  }),
  new EmployeeModel({
    Id: "9",
    Name: "Николай",
  }),
]);

const selectedEmployees = ref(new Array<string>());

const selectedOptions = computed<Array<EmployeeModel>>(() =>
  options1.value.filter((option : any) =>
    selectedEmployees.value.some((employeeId) => option.Id === employeeId)
  )
);

const selectEmployee = (employeeId: string) => {
  selectedEmployees.value.push(employeeId);
};

const unSelectEmployee = (employeeId: string) => {
  selectedEmployees.value = selectedEmployees.value.filter(
    (_employeeId) => _employeeId !== employeeId
  );
};

const toggleSelectEmployee = (employeeId: string) => {
  if (selectedEmployees.value.includes(employeeId)) {
    unSelectEmployee(employeeId);
  } else {
    selectEmployee(employeeId);
  }
};






class PriorityDropdownOptionModel implements ITirPmDropdownOption {
  Id!: string;
  Name!: string;
  Color!: string;

  constructor(obj?: Partial<PriorityDropdownOptionModel>) {
    Object.assign(this, obj);
  }
}
const options = [
  new PriorityDropdownOptionModel({
    Id: "1421244",
    Name: "Высокий",
    Color: "#2A77EF",
  }),
  new PriorityDropdownOptionModel({
    Id: "14212sdfsd44",
    Name: "Низкий",
    Color: "green",
  }),
  new PriorityDropdownOptionModel({
    Id: "ttew",
    Name: "Очень высокий",
    Color: "red",
  }),
  new PriorityDropdownOptionModel({
    Id: "asfff",
    Name: "Обычный",
    Color: "orange",
  }),
];
const selectedOption = ref<PriorityDropdownOptionModel>();

const selectOption = (option: PriorityDropdownOptionModel) => {
  selectedOption.value = option;
};


function toBackStep() {
	
}
const isShow = ref(false)
const numberStep = ref(1)


const values = ref(0)
const selectedData= ref("")
function loggin(value: any)
{
	console.log("login", value);
	
}

const count = ref(0); // Переменная для подсчета
const message = ref(""); // Переменная для сообщения
const checked = ref(true);
const status = ref(3);
const tabs = ["A", "B", "C", "D", "E", "F", "G"];
const stateTabs = ref(tabs[0]);

const currentPageNum = ref(1);
const limitPerPage = ref(10);
const totalPageNum = ref(200);
/**
 * Функция для изменения лимита показываемых записей на страницу
 */
const changeLimitPerPage = (newPerValue: number) => {
	limitPerPage.value = newPerValue;
};

/**
 * Параметры колонок таблицы на странице (ширина колонок)
 */
const columnTableSetting = ref(["auto", "auto", "20%", "30%"]);
// // Определение эмиттеров событий компонента
const emits = defineEmits<{
	clickLogout: []; // Событие при клике на кнопку "Выход"
	"update:message": [string]; // Событие обновления сообщения
}>();
const originalCode = `
        <TirPmButton :variant="TirPmButtonVariantEnum.AccentState">
          Без названия
        </TirPmButton>
      `;

// // Отслеживание изменений пропса isCompact
// watch(
//   () => props.isCompact,
//   () => {
//     if (props.isCompact) {
//       console.log("Свойство isCompact поменялось на true");
//     }
//   }
// );

// const latitude = computed({
// get() {
// return lat.value || props.Latitude || 0;
// },
// set(newValue: number) {
// console.log(`newValue`, newValue);
// lat.value = newValue;
// },
// });
// // Блок переменных

// // Жизненный цикл компонента (при монтировании)
// onMounted(() => {
//   console.log("Компонент монтирован.");
// });

// // Вычисляемое свойство (двойное значение счетчика)
// const doubledCount = computed(() => count.value * 2);

// // Функция для увеличения счетчика
// function increment() {
//   count.value++;
// }

// // Функция для изменения сообщения и эмиттинга события обновления
function changeMessage() {
	message.value = "Новое сообщение!";
	emits("update:message", message.value);
}
</script>

<style lang="scss">
.stend-page {
	padding: 10px;

	.stend-wrap {
		border: 1px solid #ccc;
		display: flex;
		margin: 10px;

		.stend-element {
			flex: 1 1 50%;
			padding: 10px;
		}

		.stend-code {
			flex: 1 1 auto;
			padding: 10px;
		}
	}

	pre {
		background-color: #2d2d2d;
		/* Темный фон */
		color: #f8f8f2;
		/* Основной текст */
		padding: 16px;
		/* Внутренние отступы */
		border-radius: 8px;
		/* Округление углов */
		font-family: 'Fira Code', monospace;
		/* Моноширинный шрифт */
		font-size: 14px;
		/* Размер шрифта */
		line-height: 1.5;
		/* Межстрочный интервал */
		overflow-x: auto;
		/* Горизонтальная прокрутка для длинных строк */
		white-space: pre-wrap;
		/* Перенос длинных строк */
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
		/* Тень для красоты */
		border-left: 5px solid #50fa7b;
		/* Линия для обозначения кода */
	}

	code {
		display: block;
		color: #f8f8f2;
		/* Цвет текста внутри <code> */
	}

	pre::-webkit-scrollbar {
		width: 8px;
	}

	pre::-webkit-scrollbar-thumb {
		background-color: #444;
		/* Цвет полосы прокрутки */
		border-radius: 4px;
	}

	pre::-webkit-scrollbar-track {
		background-color: #2d2d2d;
	}

	/* Подсветка кода (пример для ключевых слов, строк и комментариев) */
	.keyword {
		color: #ff79c6;
		/* Цвет ключевых слов */
	}

	.string {
		color: #f1fa8c;
		/* Цвет строк */
	}

	.comment {
		color: #6272a4;
		/* Цвет комментариев */
		font-style: italic;
	}
}
</style>
